import ThreeTestFC from "./ThreeTestFC";

const Wrapper3D: React.FC = () => {

    return (
        <>
            <ThreeTestFC time={new Date().getTime()} />
        </>
    );

}
export default Wrapper3D;